module.exports = __webpack_public_path__ + "img/DE06276.e49193e1.png";